import { render, staticRenderFns } from "./Articles2.vue?vue&type=template&id=64d70a5a&"
import script from "./Articles2.vue?vue&type=script&lang=js&"
export * from "./Articles2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports